import { css } from '@emotion/core';

import headingStyle from '@/src/shared/components/Heading/style';
import linkStyle from '@/src/shared/components/Link/style';
import { bp } from '@/styles';

export function replaceSpaceAndBr(html = '') {
  return html.replace(/&nbsp;/g, '').replace(/<br><br>/g, "<div class='lineBreak'></div>");
}

export const stInnerContentStyle = css`
  * {
    font-family: 'Lato', sans-serif;
    font-size: 1.6rem;
  }
  h2,
  h3,
  h4 {
    &,
    & * {
      ${headingStyle.h['3']};
      ${headingStyle.theme.primaryGray};
      ${headingStyle.weight.bold};
      margin-bottom: 16px;
    }
  }
  h5 {
    ${headingStyle.h['5']};
  }
  h6 {
    ${headingStyle.h['6']};
  }
  tbody > tr > td > {
    p {
      display: block;
      margin-bottom: 1em;
    }
  }
  > p {
    margin-bottom: 16px;
    font-size: 1.6rem;
    line-height: 2.8rem;
  }
  .lineBreak {
    display: block;
    margin-bottom: 16px;
  }
  > span,
  #topnote {
    > ul {
      display: block;
      > li {
        display: block;
        margin-bottom: 16px;
      }
    }
  }
  > span {
    &:nth-of-type(2) {
      > ul {
        &:nth-of-type(n + 3) {
          display: flex;
          flex-wrap: wrap;
          > li {
            &:first-of-type {
              flex: 1 0 100%;
              margin-bottom: 0;
              text-decoration: underline;
              @media ${bp.md} {
                flex-basis: 250px;
                text-decoration: none;
              }
            }
            &:last-child {
              flex: 0 1 100%;
              @media ${bp.md} {
                flex-basis: calc(100% - 250px);
              }
            }
          }
        }
      }
    }
    &:nth-of-type(3) {
      /* Nubmer of Companies Writing Each Line */
      > ul {
        &:first-of-type {
        }
      }
    }
    &:nth-of-type(4) {
      /* NAIC Profitability Results */
    }
  }
  #topnote {
    > ul {
      &:nth-of-type(2) {
        display: flex;
        flex-wrap: wrap;
        > li {
          flex: 0 1 100%;
          @media ${bp.lg} {
            flex-basis: 50%;
          }
        }
      }
    }
  }
  a {
    ${linkStyle.link};
  }
`;
